
<h3>Stock <span class="highlight">(Click on an stock item to edit)</span></h3>
<a routerLink="/addstock" routerLinkActive="active" class="btn btn-default">Add Stock</a>
<hr>

<div class="container divtable">
    <div class="divtablebody">
 
        <div class=" divrow">
            <div class="coltitle   appcol datecolsto">Stock Date</div>
            <div class="coltitle   appcol productcolsto">Product Code</div> 
            <div class="coltitle   appcol volumecolsto">Volume</div>
            <div class="coltitle   appcol volidcolsto">Volume ID</div>

            <div class="coltitle   appcol btncolsto">&nbsp;</div> 
            
        </div>
         @for (stock of stocks; track stock.id) {
        <div class=" divrow" (click)="onEdit(stock)">

            <!-- {{stock.warehousecode+": "+stock.description}} -->
            <div class=" appcol datecolsto appcell">{{stock.stockdate | date:'MM/dd/yyyy'}}</div>
                
            <div class=" appcol productcolsto appcell">{{stock.productcode+": "+stock.pdescription}}</div>
            
            <div class=" appcol volumecolsto appcell">{{stock.volume}}</div>
            <div class=" appcol volidcolsto appcell">{{ stock.volumeid == "B" ? "Base Unit" : stock.volumeid == "L" ? "Liter" : stock.volumeid == "P" ? "Pack" : stock.volumeid == "O" ? "Other" : stock.volumeid == "C" ? "Case" : "Unknown" }}</div>

             <div class="s appcol btncolsto">
              <button class="delete btn-xs btn-danger" (click)="deleteStock(stock); $event.stopPropagation()">Delete</button>    
            </div>
        </div>
        }
     </div>
</div>